import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity'
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import NoDataBoundary from 'components/atoms/no-data-boundary/NoDataBoundary'
import LeadsList from 'components/organisms/leads/leads-list/LeadsList'
import { TeamHeaders } from 'lib/helpers/constants/columns/teamHeaders'
import { lastTenLeads } from 'lib/helpers/constants/widget-headers/lastTenLeads'
import { lastTenPendings } from 'lib/helpers/constants/widget-headers/lastTenPendings'
import { leadsList } from 'lib/helpers/constants/widget-headers/leadsList'
import { pendingHeaders } from 'lib/helpers/constants/widget-headers/pendingsHeaders'
import { recentCustomers } from 'lib/helpers/constants/widget-headers/recentCustomers'
import { unassignedAppointments } from 'lib/helpers/constants/widget-headers/unassignedAppointments'
import { useWidgetData } from 'lib/hooks/queries/Dashboard/useWidgetData'
import React, { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    api: string
    name: string
    setModalData: (data: any) => void
}

const ListWidget: FC<Props> = ({ api, name, setModalData }) => {

    const { t } = useTranslation()

    const { data, isLoading } = useWidgetData({ endpoint: api, params: {}, type: name })

    const headers = useMemo(
        () => {
            switch (name) {
                case 'Lead Latest Activities':
                    return lastTenLeads({ setModalData });;
                case 'Lead Latest List':
                    return leadsList({ setModalData });;
                case 'Unassigned Appointments':
                    return unassignedAppointments({ setModalData });;
                case 'Customers Latest List':
                    return recentCustomers({ setModalData });;
                case 'Customer Pendings Latest List':
                    return lastTenPendings({ setModalData });
                case 'Own Pendings List':
                    return pendingHeaders({ setModalData, isOwn: true });
                case 'Appointment Pendings List':
                    return pendingHeaders({ setModalData });
                case 'Leads Pendings List':
                    return pendingHeaders({ setModalData });
                case 'Data Sharing Teams':
                    return TeamHeaders(false);
                case 'Data Sharing Brokers':
                    return TeamHeaders(true);
                default:
                    break;
            }
        },
        [name, setModalData],
    )



    if (isLoading) return <LoadingScreen />

    return (
        <div className='w-full h-full bg-white border border-[#F2F4F7] rounded-2xl p-5'>
            <div className="pb-5">
                <div className='text-primaryTextColor font-inter-bold xl:text-lg 2xl:text-xl'>
                    {t(name)}
                </div>
            </div>
            <div className='h-[calc(100%-50px)] overflow-auto'>

                <NoDataBoundary
                    condition={(data as any).data?.length > 0}
                    fallback={<EmptyEntity name={t(name)} />}>
                    <LeadsList
                        dataCols={headers}
                        data={(data as any)?.data}
                    />
                </NoDataBoundary>

            </div>
        </div>
    )
}

export default ListWidget